import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import Input from "@/components/Usados/InputField";
import Label from "@/components/Usados/Label";
import Button from "@/components/ui/button/Button";
import Switch from "@/components/form/switch/Switch";
import Alert from "@/components/ui/alert/Alert";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { apiFetch } from "@/service/api";

export default function CreateSucursal() {
  const navigate = useNavigate();
  const initialFormState = {
    nombre: "",
    direccion: "",
    ciudad: "",
    pais: "",
    telefono: "",
    estado: true,
  };

  const [form, setForm] = useState<any>(initialFormState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  function handleChange(e: any) {
    const { name, value } = e.target;
    setForm((prev: any) => ({ ...prev, [name]: value }));
  }

  const handleSwitchChange = (checked: boolean) => {
    setForm((prev: any) => ({ ...prev, estado: checked }));
  };

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const response = await apiFetch(`sucursales/create`, {
        method: "POST",
        body: JSON.stringify(form),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al crear la sucursal");
      }
      setSuccess(true);
      setForm(initialFormState);
      setTimeout(() => navigate("/multiempresa/sucursales"), 1000);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <PageBreadcrumb pageTitle="Crear Sucursal" />
      <div className="min-h-screen rounded-2xl border border-gray-200 bg-white px-5 py-7 dark:border-gray-800 dark:bg-white/[0.03] xl:px-10 xl:py-12">
        <h3 className="mb-8 font-semibold text-gray-800 text-center text-theme-xl dark:text-white/90 sm:text-2xl">
          Crear Nueva Sucursal
        </h3>
        {error && (
          <div className="mb-6">
            <Alert variant="error" title="Error" message={error} />
          </div>
        )}
        {success && (
          <div className="mb-6">
            <Alert
              variant="success"
              title="exito"
              message="Sucursal creada correctamente. Redirigiendo..."
            />
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-2">
            <div className="lg:col-span-2">
              <Label>Nombre de la Sucursal</Label>
              <Input
                name="nombre"
                type="text"
                placeholder="Ej: Sucursal Norte"
                value={form.nombre}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Direccion</Label>
              <Input
                name="direccion"
                type="text"
                value={form.direccion}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Ciudad</Label>
              <Input
                name="ciudad"
                type="text"
                value={form.ciudad}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Pais</Label>
              <Input
                name="pais"
                type="text"
                value={form.pais}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Telefono</Label>
              <Input
                name="telefono"
                type="text"
                value={form.telefono}
                onChange={handleChange}
                required
              />
            </div>
            <div className="flex items-center gap-3">
              <Label>Estado Activo</Label>
              <Switch
                label=""
                defaultChecked={form.estado}
                onChange={handleSwitchChange}
              />
            </div>
          </div>
          <div className="mt-10 flex justify-end gap-3">
            <Button
              variant="outline"
              size="md"
              type="button"
              onClick={() => navigate("/multiempresa/sucursales")}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="md"
              type="submit"
              disabled={loading}
            >
              {loading ? "Guardando..." : "Crear Sucursal"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
